/*
 * BeeCaramulo Apiturismo - v0.1.0
 * Author: truebond.pt
 * 
 * Form
 */

import { useState } from "react";
import { Alert, Button, Col, Form, Row } from "react-bootstrap";

// Styles
import "./style.scss";

// Data
import {FORM} from '../../../../data/Form';

function ContactForm(props){    
    const formData = FORM;
    const formUserData = new FormData();

    const [name,setName] = useState('')
    const [email,setEmail] = useState('')
    const [message,setMessage] = useState('')
    const [subject,setSubject] = useState('')

    const [alert, setAlert] = useState('')
    const [show, setShow] = useState(true);

    const [validated, setValidated] = useState(false);
    const [status, setStatus] = useState(formData.submitButton.holding);

    const handleSubmit = (event) => {
        event.preventDefault();
        const form = event.currentTarget;

        if (form.checkValidity() === false) {
            event.stopPropagation();
        }
        
        setValidated(true);
        setStatus(formData.submitButton.sending);
        
        formUserData.append('UserName', name);
        formUserData.append('EmailTo', email);
        formUserData.append('subject', subject);
        formUserData.append('body', message);
        
        const response = fetch("https://api.beecaramulo.pt/api/Email/sendEmailTemplate", {
            method: "POST",
            body: formUserData
        })
        .then((resp) => {
            if(!resp.ok){
                setAlert(
                    <Alert className="mt-1" variant="danger" onClose={() => setShow(false)} dismissible>
                        <Alert.Heading>{formData.messages.errorHeading}</Alert.Heading>
                        <p>{formData.messages.error}</p>
                    </Alert>);

                return Promise.reject();
            }

            setAlert(
                <Alert className="mt-1" variant="success" onClose={() => setShow(false)} dismissible>
                    <p>{formData.messages.success}</p>
                </Alert>
            );

            setShow(true);
            
            // setMessage('');
            // setName('');
            // setSubject('');
            // setEmail('');
        })
        .catch(error => {
            setAlert(
                <Alert className="mt-1" variant="danger" onClose={() => setShow(false)} dismissible>
                    <Alert.Heading>{formData.messages.errorHeading}</Alert.Heading>
                    <p>{formData.messages.error}</p>
                </Alert>);
            
            setShow(true);
        });
        
        setStatus(formData.submitButton.holding);
    };

    return (
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <Row>
                <Form.Group className="mb-3" as={Col} md="6" controlId="validationCustomUsername">
                    <Form.Control
                        type="text"
                        placeholder={formData.placeholders.name}
                        value={name}
                        onChange={(e)=>setName(e.target.value)}
                        required
                    />
                    <Form.Control.Feedback type="invalid">
                        {formData.placeholdersError.name}
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="mb-3" as={Col} md="6" controlId="validationCustomEmail">
                    <Form.Control
                        name="EmailTo"
                        type="email"
                        placeholder={formData.placeholders.email}
                        value={email}
                        onChange={(e)=>setEmail(e.target.value)}
                        required
                    />
                    <Form.Control.Feedback type="invalid">
                        {formData.placeholdersError.email}
                    </Form.Control.Feedback>
                </Form.Group>
            </Row>

            <Form.Group className="mb-3" controlId="validationCustomSubject">
                <Form.Control 
                    type="text"
                    placeholder={formData.placeholders.subject}
                    value={subject}
                    onChange={(e)=>setSubject(e.target.value)}
                    required
                />
                <Form.Control.Feedback type="invalid">
                    {formData.placeholdersError.subject}
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId="validationCustomMessage">
                <Form.Control 
                    as="textarea"
                    rows={5}
                    placeholder={formData.placeholders.message}
                    value={message}
                    onChange={(e)=>setMessage(e.target.value)}
                    required
                />
                <Form.Control.Feedback type="invalid">
                    {formData.placeholdersError.message}
                </Form.Control.Feedback>
            </Form.Group>
            
            <Form.Group className="mb-3">
                <Form.Check
                    required
                    label={formData.placeholders.rgpd}
                    feedback={formData.placeholdersError.rgpd}
                    feedbackType="invalid"
                />
            </Form.Group>
            <Row>
                <Col className="text-center">
                    <Button type="submit">{status}</Button>
                </Col>
            </Row>
            
            {/* Alerts */}
            {show? alert : null}
        </Form>
    );
}

export default ContactForm;